import AuthService from '@/business/modules/auth/auth.service';
import type {
	IAdminRecoveryCodeLoginPayload,
	IAdminTotpLoginPayload,
	IRegisterUserRequest,
	IUpdateUserInformation,
	IVerifyOtpResponse,
	ISwitchContextRequest,
	ISwitchContextResponse,
} from '@/business/modules/auth/auth.model';

class AuthController {
	static #instance: AuthController;
	private readonly service;

	private constructor() {
		this.service = AuthService.getInstance();
	}

	public static getInstance(): AuthController {
		if (!AuthController.#instance) {
			AuthController.#instance = new AuthController();
		}
		return AuthController.#instance;
	}

	async signup(data: IRegisterUserRequest) {
		return await this.service.signup(data);
	}

	async signupForReservation(data: IRegisterUserRequest) {
		return await this.service.signupForReservation(data);
	}

	loginInit(phoneNumber: string) {
		return this.service.loginInit(phoneNumber);
	}

	loginInitForReservation(phoneNumber: string) {
		return this.service.loginInitForReservation(phoneNumber);
	}

	verifyOtp(otpCode: string): Promise<IVerifyOtpResponse> {
		return this.service.verifyOtp(otpCode);
	}

	loginAsAdmin(otpCode: string) {
		return this.service.loginAsAdmin(otpCode);
	}

	verifyAdminTotpLogin(payload: IAdminTotpLoginPayload) {
		return this.service.verifyAdminTotpLogin(payload);
	}

	verifyAdminRecoveryCodeLogin(payload: IAdminRecoveryCodeLoginPayload) {
		return this.service.verifyAdminRecoveryCodeLogin(payload);
	}

	updateUserInformation(userData: IUpdateUserInformation) {
		return this.service.updateUserInformation(userData);
	}

	loginByRefreshToken() {
		return this.service.loginByRefreshToken();
	}

	logout() {
		return this.service.logout();
	}

	getUserInformation() {
		return this.service.getUserInformation();
	}

	getAvailableContexts() {
		return this.service.getAvailableContexts();
	}

	switchContext(data: ISwitchContextRequest): Promise<ISwitchContextResponse> {
		return this.service.switchContext(data);
	}
}

export default AuthController;
